import { useState } from "react";
import { Icon } from "@iconify/react";

const ExpandableList = ({ listItems }) => {
  const [showAll, setShowAll] = useState(false);
  const visibleItems = showAll ? listItems : listItems.slice(0, 3);

  return (
    <div className="row gy-3">
      {visibleItems?.map((item, index) => (
        <div
          className="col-12"
          key={index}
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-delay={index * 40}
        >
          <div className="ex-box">
            <div className="row gy-4">
              <div className="col-md-4 col-lg-3">
                <div className="ex-left">
                  <h4>{item.designation}</h4>
                  <span>{item.company}</span>
                  <p>{item.duration}</p>
                  <label>{item.jobType}</label>
                </div>
              </div>
              <div className="col-md-8 col-lg-9">
                <div className="ex-right">
                  <h5>{item.companyTitle}</h5>
                  <p className="m-0">{item.companyDescription}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      {!showAll && listItems.length > 3 && (
        <div className="btn-bar">
          <button className="px-btn light" onClick={() => setShowAll(true)}>
            <span>Show More</span>{" "}
            <i>
              <Icon icon="bi:arrow-right" />
            </i>
          </button>
        </div>
      )}
    </div>
  );
};

export default ExpandableList;